import { gql } from "@apollo/client";

export const GetDashboardJunctionCount = gql`
  query GetDashboardJunctionCount(
    $token: String!
    $customerID: ID!
    $empID: ID!
  ) {
    GetDashboardJunctionCount(
      token: $token
      customerID: $customerID
      empID: $empID
    ) {
      detailedChart {
        jType
        count
        vendorWiseData {
          vendorName
          total
          WorkingData {
            total
            working
            notWorking
          }
        }
      }
      totalCountData {
        total
        working
        notWorking
      }
      signalTypeData {
        jType
        count
        working
        notWorking
      }
      vendorWiseData {
        vendorName
        total
        working
        notWorking
      }
    }
  }
`;
export const GetDashboardItemAndJunctionCount = gql`
  query GetDashboardItemAndJunctionCount(
    $token: String!
    $customerID: ID!
    $empID: ID!
  ) {
    GetDashboardItemAndJunctionCount(
      token: $token
      customerID: $customerID
      empID: $empID
    ) {
      desc
      id
      count
      tableLevel
      icon
    }
  }
`;
export const GetDashboardTicketCount = gql`
  query GetDashboardTicketCount(
    $token: String!
    $customerID: ID!
    $empID: ID!
  ) {
    GetDashboardTicketCount(
      token: $token
      customerID: $customerID
      empID: $empID
    ) {
      desc
      count
    }
  }
`;

export const GetDashboardTicketPriorityCount = gql`
  query GetDashboardTicketPriorityCount(
    $token: String!
    $customerID: ID!
    $empID: ID!
  ) {
    GetDashboardTicketPriorityCount(
      token: $token
      customerID: $customerID
      empID: $empID
    ) {
      desc
      count
    }
  }
`;

export const GetDashboardProjectDetails = gql`
  query GetDashboardProjectDetails(
    $token: String!
    $customerID: ID!
    $empID: ID!
  ) {
    GetDashboardProjectDetails(
      token: $token
      customerID: $customerID
      empID: $empID
    ) {
      id
      name
      startDate
      endDate
      vendor
    }
  }
`;

export const GetDashboardJunctionStatusCount = gql`
  query GetDashboardJunctionStatusCount(
    $token: String!
    $customerID: ID!
    $empID: ID!
  ) {
    GetDashboardJunctionStatusCount(
      token: $token
      customerID: $customerID
      empID: $empID
    ) {
      junctionStatus
      count
    }
  }
`;

export const GetItemDetatilsByNodeId = gql`
  query GetItemDetatilsByNodeId($token: String!, $id: ID!) {
    node(token: $token, id: $id) {
      ... on AtsStckItemDetails {
        prodSerialNo
        prodLatitude
        prodLongitude
        prodBatchNo
        prodExpiryDate
        prodWarrantyStartDate
        prodInstallationEndDate
        prodWarrantyEndDate
        curCompanyID
        poleNum
        ticketStatus
        prodModel
        item {
          id
          icon
          code
          desc
          enableGst
          categoryDetails {
            categoryName
          }
          subCategoryDetails {
            subCategoryName
          }
          uomDetails {
            uomDesc
          }
        }
        vendorDetails {
          desc
        }
        currentSubsidiary {
          name
        }
        currentSite {
          name
        }
        currentCompany {
          name
        }
      }
    }
  }
`;